import { SubRouteAttributes, VisitAttributes } from "@albatrosdeveloper/ave-models-package";
import { CommonModule } from "@angular/common";
import { Component, OnDestroy, ViewChild } from "@angular/core";

import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule, MatIconRegistry } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import {
  MatSidenavContainer,
} from "@angular/material/sidenav";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { MatMenuModule } from "@angular/material/menu";
import { NgSelectModule } from "@ng-select/ng-select";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatBadgeModule } from "@angular/material/badge";
import { DateHourPipe } from "app/pipes/formated-date.pipe";
import { DomSanitizer } from "@angular/platform-browser";
import { getCode } from "app/utils/method";
import { SubRouteService } from "app/modules/components/routing/sub-routes/sub-route.service";
import { ReplaySubject, takeUntil, take, Subject, Subscription } from "rxjs";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { Router } from "@angular/router";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { FilterSectionComponent } from "app/common/components/filter-section/filter-section.component";
import { BusinessPartnersFiltersComponent } from "app/modules/components/filters/business-partners-filters/business-partners-filters.component";
import { ConfigurationFiltersComponent } from "app/modules/components/filters/configuration-filters/configuration-filters.component";
import { DatesFiltersComponent } from "app/modules/components/filters/dates-filters/dates-filters.component";
import { FinanceFiltersComponent } from "app/modules/components/filters/finance-filters/finance-filters.component";
import { RoutesFiltersComponent } from "app/modules/components/filters/routes-filters/routes-filters.component";
import { StatusFiltersComponent } from "app/modules/components/filters/status-filters/status-filters.component";
import { IFilters } from "app/modules/components/filters/interfaces/filterInterface";
import { MapModalComponent } from "app/shared/components/map-modal/map-modal.component";
import { MapModalInputData } from "app/shared/components/map-modal/models/map-modal.interface";
import { MapModalTypeEnum, MonitorDocumentTypeEnum } from "app/shared/components/map-modal/models/map-modal.enum";
import { DistanceCalculatorService } from 'app/services/distanceCalculatorService.service';
import { UserRouteDisplayComponent } from 'app/shared/components/user-route-display/user-route-display.component';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { DateHelper } from "app/utils/date.helper";
import { TripService } from "../visit-report/visit-report.service";
import { TripAttributesExt } from "../visit-report/dto/visit-report.interface";
import { ModalMapComponent } from "app/modules/components/shared/modal-map/modal-map.component";


@Component({
  selector: "app-visit-tracking",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatSidenavContainer,
    MatCheckboxModule,
    MatMenuModule,
    NgSelectModule,
    MatDatepickerModule,
    FormsModule,
    MatBadgeModule,
    DateHourPipe,
    NgxMatSelectSearchModule,
    FilterComponent,
    FilterSectionComponent,
    StatusFiltersComponent,
    DatesFiltersComponent,
    ConfigurationFiltersComponent,
    RoutesFiltersComponent,
    BusinessPartnersFiltersComponent,
    FinanceFiltersComponent,
    UserRouteDisplayComponent,
    HoverMenuDirective
  ],
  providers: [{ provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
  templateUrl: "./visit-tracking.component.html",
  styleUrl: "./visit-tracking.component.scss",
  animations: [
    trigger("detailExpand", [
      state("collapsed,void", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class VisitTrackingReportComponent implements OnDestroy {
  getCode = getCode;
  displayedColumns: string[] = [
    "det",
    "map",
    "trip",
    "routeUser",
    "date",
    "visitsTotal",
    "visitsDay",
    "visitsPending"
  ];

  // dataSource = new MatTableDataSource<TripAttributesExt>([]);
  selectedTrip: any | null = null;

  dataSource: VisitAttributes[] = [];
  totalItems = 0;
  search: string = "";
  pageSize = 50;
  pageIndex: number = 1;
  sortActive = null;
  sortDirection = "asc";

  searchQuery: string = "";

  //DETAIL
  displayedColumnsDetail: string[] = [
    "geo",
    "bPartner",
    "visit",
    "documentNumber",
    "dateTimeStart",
    "duration",
    "location",
    "wasTheVisitOnSite",
    "validVisit",
  ];
  dataSourceDetail = new MatTableDataSource<VisitAttributes>([]);

  filter = {
    dateini: new Date(),
    dateend: new Date(),
  };
  subRouteList: SubRouteAttributes[] = [];


  /** control for the selected route for multi-selection */
  public routeMultiCtrl: FormControl<SubRouteAttributes[]> = new FormControl<
    SubRouteAttributes[]
  >([], Validators.required);

  /** control for the MatSelect filter keyword multi-selection */
  public routeMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  /** list of route filtered by search keyword */
  public filteredRoutes: ReplaySubject<SubRouteAttributes[]> = new ReplaySubject<
    SubRouteAttributes[]
  >(1);

  /** local copy of filtered route to help set the toggle all checkbox state */
  protected filteredRouteCache: SubRouteAttributes[] = [];


  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  protected _onDestroy = new Subject<void>();

  //BUSCADOR
  searchSubscription: Subscription;

  form: FormGroup;

  //map
  isNew: boolean = true;

  loadFiltersData = false;

  constructor(
    private tripService: TripService,
    private subRouteService: SubRouteService,
    private snackBar: MatSnackBar,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private dialog: MatDialog,
    private readonly router: Router,
    private readonly searchService: SearchService,
    private fb: FormBuilder,
    private distanceCalculator: DistanceCalculatorService
  ) {
    const today = new Date();
    this.form = this.fb.group({
      start: [today],
      end: [today],
      exp_start: [],
      exp_end: [],
      companyId: [],
      salesOfficeId: [],
      customerId: [],
      subRouteId: [],
      bankId: [],
      paymentConditionId: [],
    });
    this.matIconRegistry.addSvgIcon(
      "excel",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/mdi--file-excel.svg"
      )
    );
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
  }

  protected filterRouteMulti() {
    if (!this.subRouteList) {
      return;
    }
    // get the search keyword
    let search = this.routeMultiFilterCtrl.value;
    if (!search) {
      this.filteredRouteCache = this.subRouteList;
      this.filteredRoutes.next(this.subRouteList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar los precios por nombre o código
    this.filteredRouteCache = this.subRouteList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material?.externalKeys?.code.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches;
    });
    this.filteredRoutes.next(this.filteredRouteCache);
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredRoutes
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.routeMultiCtrl.patchValue(val);
        } else {
          this.routeMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateRoute() {
    let filteredLength = 0;
    if (this.routeMultiCtrl && this.routeMultiCtrl.value) {
      this.filteredRouteCache.forEach((el) => {
        if (this.routeMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 && filteredLength < this.filteredRouteCache.length;
      this.isChecked =
        filteredLength > 0 && filteredLength === this.filteredRouteCache.length;
    }
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  findAllWithCount(): void {
    // const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortFieldByTrip();
    const sortDirection: "ASC" | "DESC" =
      this.sort.direction === "asc" ? "ASC" : "DESC";
    const routeIds = this.routeMultiCtrl.value.map((sub: SubRouteAttributes) =>
      sub.id)

    let filter: IFilters = {
      startDate: DateHelper.getStartOfDay(this.form.get("start")?.value),
      endDate: DateHelper.getEndOfDay(this.form.get("end")?.value) ?? DateHelper.getEndOfDay(this.form.get("start")?.value) ?? null,
      companyId: this.form.get("companyId")?.value,
      salesOfficeId: this.form.get("salesOfficeId")?.value,
      customerId: this.form.get("customerId")?.value,
      subRouteId: this.form.get("subRouteId")?.value,//
    }

    /* this.tripService
      .findAllWithCountByTrip({
        currentPage: this.pageIndex,
        limitPerPage: this.pageSize,
        search: this.searchQuery,
        sort: sortField,
        sortDirection: sortDirection,
      },
        filter
      )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      }); */
  }

  downloadReport(visit: VisitAttributes) {
    const sortField = this.getSortFieldByTrip();
    const sortDirection: "ASC" | "DESC" =
      this.sort.direction === "asc" ? "ASC" : "DESC";

    this.tripService
      .exportVisitXLSX({
        search: this.searchQuery,
        sort: sortField,
        sortDirection: sortDirection,
        startDate: new Date(this.filter.dateini).toISOString(),
        endDate: new Date(
          new Date(this.filter.dateend).setHours(23, 59, 59, 999)
        ).toISOString(),
      })
      .subscribe((data: any) => {

        // Obtener la URL del archivo desde la respuesta
        const { fileUrl } = data.json(); //TODO todo

        // Descargar el archivo usando la URL proporcionada
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "Reporte.xlsx"; // Usa el nombre del archivo proporcionado o lo puedes poner fijo
        link.click();
      });
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      // this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.findAllWithCount();
        }
      });
  }

  private getSortFieldByTrip(): keyof VisitAttributes {
    const validSortFields: (keyof VisitAttributes)[] = ["statusId"];
    return validSortFields.includes(this.sort.active as keyof VisitAttributes)
      ? (this.sort.active as keyof VisitAttributes)
      : "trip.dateHourStart" as keyof VisitAttributes;
  }

  private getSortField(): keyof TripAttributesExt {
    const sortFieldMapping: Record<string, keyof TripAttributesExt> = {
      trip: <any>"trip.id",
      /*status: "statusERP",
      type: "type",
      trip: <any>"trip.id",
      subRoute: <any>"subRoute.name",
      user: <any>"user.user_login.username",
      soldTo: <any>"soldTo.name",
      documentNumber: "serial",
      class: <any>"class.name",
      date: "deliveryDateTime",
      creation: "creationDateTime",*/
      //creation: "creationDateTime",
    };
    return sortFieldMapping[this.sortActive] || "dateHourEndTeoric";
  }

  toggleDetails(trip: any): void {
    if (this.selectedTrip && this.selectedTrip.trip.id === trip.trip.id) {
      this.closeDetails();
      return;
    }

    this.selectedTrip = trip;
    this.onFilterVisits(trip);
  }

  closeDetails(): void {
    this.selectedTrip = null;
  }

  onClearFilter() {
    this.form.reset({
      start: new Date(),
      end: new Date(),
    });
    this.findAllWithCount();
  }

  changeSort(e) {
    this.sortActive = e.active;
    this.sortDirection = e.direction;
  }

  clearFilters(): void {
    this.routeMultiCtrl.setValue([]);
    this.searchQuery = "";
    this.findAllWithCount();
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.findAllWithCount();
  }

  onFilterVisits(element: any) {

    this.dataSourceDetail.data = [];
    this.dataSourceDetail.data = element.visits;

    this.dataSourceDetail.data = element.visits.map((detail, index) => {
      const appCoords = detail?.geoPoint ?? "-";
      const aveCoords = detail?.address?.[0]?.geolocationPoint ?? "-";
      let distance: number | null = null;
      let distanceMeters: number | null = null;
      if (appCoords !== "-" && aveCoords !== "-") {
        distanceMeters = this.distanceCalculator.calculateDistanceMeters(
          appCoords as [number, number],
          aveCoords as [number, number]
        );
      }
      return {
        ...detail,
        distance: this.formatDistance(distanceMeters)

      };
    });
  }

  private formatDistance(meters: number | null): string | null {
    if (meters === null) return null;
    if (meters >= 1000) {
      return `${(meters / 1000).toFixed(2)} km`;
    } else if (meters >= 10) {
      return `${meters.toFixed(2)} m`;
    } else {
      return `${meters.toFixed(2)} m`;
    }
  }


  openModal(element, type): void {
    if (this.isNew) {
      const data: MapModalInputData = {
        type: type == 'H' ? MapModalTypeEnum.VISIT_ROUTE : MapModalTypeEnum.SIMPLE_TWO,
        tripId: null,
        element: element,
        document: MonitorDocumentTypeEnum.NONE,
        groupDocuments: [],
        map: {
          displayMode: 'drawer',
          captions: { title: 'Ubicación' }
        }
      }

      this.openMap(data)
    } else {
      this.dialog.open(ModalMapComponent, {
        width: "90%",
        data: { element, type: type },
        disableClose: true,
      });
    }
  }

  openMap(data) {
    this.dialog.open(MapModalComponent, {
      width: '90%',
      //height: '80%',
      data: data
    });
  }

  goToTravel(element: VisitAttributes) {
    if (element.trip?.id) {
      const queryParams = { tripId: element.trip.id };
      const urlTree = this.router.createUrlTree(['monitor', 'principal-screen'], { queryParams });
      const absoluteUrl = window.location.origin + this.router.serializeUrl(urlTree);
      window.open(absoluteUrl, '_blank');
    }
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
